<div class="audit-modal">
  <div class="modal-header">
    <h3>View Change</h3>
    <button class="close-btn" mat-dialog-close>X</button>
  </div>

  <div class="modal-body">
    <table class="audit-table">
      <thead>
        <tr>
          <th>Field Name</th>
          <th *ngIf="data.rowData.strStatus === 'UPDATE'">Old Value</th>
          <th>New Value</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>{{ data.rowData.strFieldname }}</td>
          <td *ngIf="data.rowData.strStatus === 'UPDATE'">{{ data.rowData.strOldValue }}</td>
          <td>{{ data.rowData.strNewValue }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>